import Grid from "@mui/material/Grid2";
import { SecondaryFilterTickBox } from "../TripRate/Filters/SecondaryFiltering/SecondaryFilterTickbox";
import Population500m from "./Population500m"

export default function PopulationFiltering() {

    return (
        <Grid container size={12}>
            <Grid container size={4} alignContent={"flex-start"}>
                <SecondaryFilterTickBox title={'Population < 1 Mile'} heading={'Population < 1 Mile'} fetchAction={'GetPopulationOneMile'} path={'secondaryFilters.populationOneMile'} id={'pop1MileId'} badgeNumber={'1'} />
                <Population500m />
            </Grid>
            <Grid container size={4} alignContent={"flex-start"}>
                <SecondaryFilterTickBox title={'Population < 5 Miles'} heading={'Population Within 5 Miles'} fetchAction={'GetPopulationFiveMile'} path={'secondaryFilters.populationFiveMile'} id='pop5MileId' badgeNumber={'2'} />
            </Grid>
            <Grid container size={4} alignContent={"flex-start"}>
                <SecondaryFilterTickBox title={'Car Ownership < 5 Miles'} heading={'Car Ownership < 5 Miles'} fetchAction={'GetCarOwnershipFiveMile'} path={'secondaryFilters.carOwnership'} id='car5Id' badgeNumber={'3'} />
            </Grid>
        </Grid>
    );
}